"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M16 6c-.28 0-.53.11-.71.29L10 11.59l-5.29-5.3a1.003 1.003 0 00-1.42 1.42l6 6c.18.18.43.29.71.29s.53-.11.71-.29l6-6A1.003 1.003 0 0016 6z"];
//# sourceMappingURL=chevron-down.js.map